import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePreview } from '../App';

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/features', label: 'Features' },
  { href: '/templates', label: 'Templates', highlight: true },
  { href: '/pricing', label: 'Pricing' },
  { href: '/docs', label: 'Docs' },
];

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { isPreviewMode } = usePreview();

  return (
    <nav className={`fixed left-0 right-0 z-50 bg-base/90 backdrop-blur-xl border-b border-zinc-800 ${isPreviewMode ? 'top-8' : 'top-0'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/owl-logo.svg" 
              alt="WISERWEB" 
              className="h-10 group-hover:opacity-90 transition-opacity"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === link.href
                    ? 'text-white bg-zinc-800'
                    : link.highlight
                    ? 'text-orange-400 hover:text-orange-300 hover:bg-zinc-800/50'
                    : 'text-zinc-400 hover:text-white hover:bg-zinc-800/50'
                }`}
              >
                {link.label}
                {link.highlight && (
                  <span className="ml-1.5 px-1.5 py-0.5 text-[10px] bg-orange-500/20 text-orange-400 rounded font-semibold">
                    NEW
                  </span>
                )}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://dashboard.wiserwebcloud.com/login"
              className="px-4 py-2 text-sm font-medium text-zinc-400 hover:text-white transition-colors"
            >
              Log in
            </a>
            <a
              href="https://dashboard.wiserwebcloud.com/signup"
              className="px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-red-500 to-red-600 rounded-lg hover:shadow-glow transition-all duration-300 hover:-translate-y-0.5"
            >
              Get Started
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 text-zinc-400 hover:text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="material-icons">
              {mobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-zinc-900 border-t border-zinc-800">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'text-white bg-zinc-800'
                    : 'text-zinc-400 hover:text-white hover:bg-zinc-800/50'
                }`}
              >
                {link.label}
                {link.highlight && (
                  <span className="ml-2 px-1.5 py-0.5 text-[10px] bg-orange-500/20 text-orange-400 rounded font-semibold">
                    NEW
                  </span>
                )}
              </Link>
            ))}
            <div className="pt-4 border-t border-zinc-800 space-y-2">
              <a
                href="https://dashboard.wiserwebcloud.com/login"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-4 py-3 text-sm font-medium text-zinc-400 hover:text-white"
              >
                Log in
              </a>
              <a
                href="https://dashboard.wiserwebcloud.com/signup"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-4 py-3 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-red-500 to-red-600 rounded-lg text-center"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
